import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { green } from '@material-ui/core/colors';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Line', value: data.isLineEnabled ? <CheckIcon style={{ color: green[600] }} fontSize="small" /> : '' },
        { label: 'Company Name', value: data.companyName },
        { label: 'Type', value: data.type === 1 ? 'Customer' : 'Vendor' },
        { label: 'GST Number', value: data.gstNumber },
        { label: 'Phone Number', value: data.phoneNumber },
        { label: 'Email Address', value: data.emailAddress },
        { label: 'Address', value: data.address, fullWidth: true },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.primaryContact}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
